export default "__VITE_ASSET__CTLEAgdX__"